module.exports = __webpack_public_path__ + "static/media/data-processing.49182e01.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/ai/icons/data-processing.gif
// module id = 3777
// module chunks = 0